import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import has from "lodash/has";
import { hasProperty } from "helpers/object";
import Layout from "layouts/DashboardManage";
import { getUser, updateUser } from "store/actions/userAction";
import { getAllRoles } from "store/actions/roleAction";
import { notifyApiError } from "components/Notification";
import SubmitButton from "components/Forms/Buttons/Submit";
import Textbox from "components/Forms/Elements/Textbox";
import AutoSuggest from "components/Forms/Elements/AutoSuggest";
import { SpinnerSyncBlock } from "components/Spinner";
import Translate from "helpers/Translate";

export class Edit extends Component {
  state = {
    fullname: "",
    email: "",
    role: {}
  };

  componentDidMount() {
    this.props.getUser(this.props.match.params.userId);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.user !== this.props.user && this.props.user) {
      this.setState({
        fullname: this.props.user.data.fullname,
        email: this.props.user.data.email,
        role: this.props.user.data?.role
      });

      this.props.getAllRoles({
        type: hasProperty(() => this.props.user.data.type, "")
      });
    }

    // When the user is updated successfully, we will redirect to step 2
    if (
      prevProps.updateUserResponse !== this.props.updateUserResponse &&
      has(this, "props.updateUserResponse.id")
    ) {
      // Redirect to manage page
      return this.props.history.push(`/manage/users`);
    }

    // When there was a problem updating the User
    if (
      prevProps.errorUser !== this.props.errorUser &&
      this.props.errorUser &&
      Object.keys(this.props.errorUser).length > 0
    ) {
      notifyApiError(this.props.errorUser);
    }
  }

  handleChange = e => {
    const target = e.target;
    this.setState(() => ({
      [target.name]: target.value
    }));
  };

  handleUpdate = () => {
    this.props.updateUser({
      id: this.props.match.params.userId,
      data: this.state
    });
  };

  render() {
    return (
      <Layout>
        {this.props.isLoading && <SpinnerSyncBlock />}
        <div className="add-edit">
          <h1 className="title mb-30">{Translate({ id: "edit_user" })} </h1>

          <div className="center-form">
            <div className="form-wrapper mb-20">
              <div className="form-group mb-10">
                <label htmlFor="fullname">
                  * {Translate({ id: "fullname" })} :
                </label>
                <Textbox
                  type="text"
                  placeholder="John Doe"
                  id="fullname"
                  name="fullname"
                  fieldValue={this.state.fullname}
                  onChange={this.handleChange}
                  onReturnKey={this.handleUpdate}
                  errors={this.props.errorUser}
                  errorKey="fullname"
                  formErrorClass="form-error"
                />
              </div>
              <div className="form-group mb-10">
                <label htmlFor="email">* {Translate({ id: "email" })} :</label>
                <Textbox
                  type="email"
                  placeholder="user@example.com"
                  id="email"
                  name="email"
                  fieldValue={this.state.email}
                  onChange={this.handleChange}
                  onReturnKey={this.handleUpdate}
                  errors={this.props.errorUser}
                  errorKey="email"
                  formErrorClass="form-error"
                />
              </div>
              <div className="form-group mb-10">
                <label htmlFor="role">* {Translate({ id: "role" })} :</label>
                <AutoSuggest
                  data={
                    has(this, "props.roles.data") ? this.props.roles.data : []
                  }
                  displayItemInList="name"
                  keyword={keyword =>
                    this.props.getAllRoles({
                      name: keyword,
                      type: hasProperty(() => this.props.user.data.type, "")
                    })
                  }
                  onSelect={item => this.setState({ role: item })}
                  placeholder={Translate({ id: "type_to_search_role" })}
                  fieldValue={this.state.role?.name}
                  errors={this.props.errorUser}
                  errorKey="role"
                />
              </div>
            </div>
          </div>

          <div className="save-cancel-buttons">
            <Link
              to={`/manage/users`}
              className="btn manage-btn-cancel"
            >
              <i className="far fa-times-circle mr-10"></i> {Translate({ id: "cancel" })}
            </Link>

            <SubmitButton
              className="btn btn-primary manage-btn-save"
              buttonIconClass="fas fa-save mr-10"
              buttonText={Translate({ id: "save_changes" })}
              btnId="create"
              isLoading={this.props.isLoading}
              handleSubmit={this.handleUpdate}
            />
          </div>
        </div>
      </Layout>
    );
  }
}

Edit.propTypes = {
  updateUser: PropTypes.func.isRequired,
  getUser: PropTypes.func.isRequired,
  getAllRoles: PropTypes.func.isRequired,
  user: PropTypes.object,
  roles: PropTypes.object,
  updateUserResponse: PropTypes.object,
  errorUser: PropTypes.object,
  isLoading: PropTypes.bool
};

const mapStateToProps = state => {
  return {
    updateUserResponse: state.user.updateUser,
    user: state.user.getUser,
    roles: state.role.getAllRoles,
    errorUser: state.user.errorUser,
    isLoading: state.user.isLoadingUser || state.role.isLoadingRole
  };
};

export default connect(mapStateToProps, { getUser, updateUser, getAllRoles })(
  Edit
);
